<template>
  <div style="margin-top: 20px">
    <div class="goods_msg">
      <div class="goods_list">
        <div class="goods_l">物流名称</div>
        {{ oneBox.logisticsName }}
      </div>
      <div class="goods_list">
        <div class="goods_l">发货仓库</div>
        {{ oneBox.orgName }}
      </div>
      <div class="goods_list">
        <div class="goods_l">订单数量</div>
        {{ oneBox.orderCount }}
      </div>
      <div class="goods_list">
        <div class="goods_l">箱数</div>
        {{ oneBox.invoicePackageSize }}（本箱为第{{ oneBox.packageSize }}箱）
      </div>
    </div>
    <div class="box_wrap">
      <div
        class="wrap_list"
        v-for="(item, index) in oneBox.packageSubInfoDtoList"
        :key="index"
      >
        <div v-show="index == 0" class="box_num">本箱内货物</div>
        <div class="product_box">
          <img class="product_img" :src="item.modelThumbnailImg" alt="" />
          <div class="product_msg">
            <div class="product_name">产品名称：{{ item.productName }}</div>
            <div class="model_name">型号名称：{{ item.modelName }}</div>
            <div class="model_num">数量：{{ item.modelCount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    oneBox: {
      type: Object,
      // default: function () { return [] }
      default: () => {},
    },
    // allBox: {
    //   type: Object,
    //   // default: function () { return [] }
    //   default: () => {},
    // },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scopen>
.goods_msg {
  width: 94%;
  margin: 0 auto;
}
.goods_list {
  font-size: 16px;
  text-align: left;
}
.goods_l {
  display: inline-block;
  width: 100px;
  color: #999999;
  margin-bottom: 18px;
  /* text-align: left; */
  /* margin-right: 20px; */
}
.product_box {
  background-color: #fff;
  /* clear: both; */
  overflow: hidden;
  padding: 10px 3%;
  /* display: flex;
  justify-content: space-between; */
}
.box_num {
  /* text-align: center; */
  padding-left: 3%;
  height: 40px;
  line-height: 40px;
  background-color: #f5f6f8;
}
.product_img {
  width: 120px;
  height: 120px;
  float: left;
  margin-right: 12px;
  /* border: 1px solid #ccc; */
}
.product_msg {
  width: 60%;
  color: #333333;
  float: left;
  font-size: 16px;
  margin-top: 10px;
  text-align: left;
}
.product_name,
.model_name,
.model_num {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/oneGoodsInfo.vue